import * as React from 'react';
import BusinessContact from './BusinessContact';
import * as Styled from './PriceTiers.styles';
import Tabs from './Tabs/Tabs';
import Cards from './Cards';
import { usePriceTiersBlock } from '@ids/context/LandingPage';
import Skeleton from '@ids/components/Layout/Skeleton';
import Divider from '@ids/components/Layout/Divider';
import Display from '@ids/components/Layout/Display';

const PriceTiersBody = () => (
    <Styled.Body>
        <Display.MobileOnly>
            <Tabs />
        </Display.MobileOnly>
        <Display.FromTablet>
            <Cards />
        </Display.FromTablet>
    </Styled.Body>
);

const PriceTiers = () => {
    const priceTiersBlock = usePriceTiersBlock();

    if (!priceTiersBlock?.priceTiers) {
        return <Skeleton />;
    }

    return (
        <React.Fragment>
            <Styled.PriceTiersSection data-testid="price-tiers-block" id="price-tiers">
                <Styled.Header>
                    <Styled.Heading>{priceTiersBlock.title}</Styled.Heading>
                    <Styled.Description>{priceTiersBlock.description}</Styled.Description>
                </Styled.Header>
                <PriceTiers.Body />
                <Styled.Footer>
                    <BusinessContact />
                </Styled.Footer>
            </Styled.PriceTiersSection>
            <Divider />
        </React.Fragment>
    );
};

PriceTiers.Body = PriceTiersBody;

export default PriceTiers;
